import { Alert, Spin } from 'antd'
import React from 'react'
import styled from 'styled-components/macro'
import { HARBOUR_MY_WORK_TITLE } from 'src/constants/harbour'
import {
  getHarbourColumnEmptyCopy,
  getHarbourMyWorkColumns,
} from 'src/utils/harbourBoard'
import { HARBOUR_TOOLTIPS } from 'src/utils/harbourTooltips'
import HarbourColumn from './HarbourColumn'

/**
 * My work — Working / Waiting / Ask sales / Ask product.
 * Parked stays hidden unless they uncheck Hide parked.
 */
const HarbourMyWork = ({
  columns = {},
  hideParked = true,
  ownerFilter,
  loading = false,
  error = null,
  now,
  startBusyVenueId = null,
  onRetry,
  onSelectVenue,
  onStartWork,
  onAskSales,
  onAskProduct,
}) => {
  const visibleColumns = getHarbourMyWorkColumns({ hideParked, ownerFilter })
  if (visibleColumns.length === 0) {
    return null
  }

  const claimedCount = visibleColumns.reduce(
    (sum, column) =>
      sum + (Array.isArray(columns[column]) ? columns[column].length : 0),
    0,
  )
  const showLoading = loading && claimedCount === 0 && !error

  return (
    <Section data-testid='harbour-my-work' title={HARBOUR_TOOLTIPS.myWork}>
      <Title>{HARBOUR_MY_WORK_TITLE}</Title>
      {error ? (
        <Alert
          type='error'
          showIcon
          message={error}
          action={
            onRetry ? (
              <button
                type='button'
                onClick={onRetry}
                data-testid='harbour-my-work-retry'
              >
                Retry
              </button>
            ) : null
          }
        />
      ) : null}
      {showLoading ? (
        <Loading data-testid='harbour-my-work-loading'>
          <Spin size='small' />
        </Loading>
      ) : null}
      <Columns>
        {visibleColumns.map(column => {
          const cards = Array.isArray(columns[column]) ? columns[column] : []
          return (
            <HarbourColumn
              key={column}
              column={column}
              cards={cards}
              emptyCopy={getHarbourColumnEmptyCopy(column)}
              now={now}
              startBusyVenueId={startBusyVenueId}
              onSelectVenue={onSelectVenue}
              onStartWork={onStartWork}
              onAskSales={onAskSales}
              onAskProduct={onAskProduct}
            />
          )
        })}
      </Columns>
    </Section>
  )
}

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm || '8px'};
  min-width: 0;
`

const Title = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.colours.broccoliGreen || '#1a1a1a'};
`

const Loading = styled.div`
  min-height: 24px;
`

const Columns = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(16.5rem, 1fr));
  gap: ${({ theme }) => theme.spacing.sm || '8px'};
  align-items: start;
`

export default HarbourMyWork
